module.exports = __webpack_public_path__ + "img/loading.e830051e.gif";